import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
// import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
// import { FileUploader } from 'ng2-file-upload';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./upload.component.scss'],
})
export class UploadComponent {
  @Input() isUploading = false;
  @Output() filetoUpload = new EventEmitter<any>();
  // name: new FormControl('', [Validators.required, Validators.minLength(3)]),
  // characterpath : new FormControl(null, [Validators.required]),
  // files = new FormGroup({
  //   file:new FormControl(null)
  // });
  file: any;
  constructor() {}

  // uploader: FileUploader = new FileUploader({
  //   url: URL,
  //   isHTML5: true
  // });
  // hasBaseDropZoneOver = false;
  // hasAnotherDropZoneOver = false;

  // Angular2 File Upload
  // fileOverBase(e: any): void {
  //   this.hasBaseDropZoneOver = e;
  // }

  // fileOverAnother(e: any): void {
  //   this.hasAnotherDropZoneOver = e;
  // }
  onFileChange(event): void {
    // console.log(event);

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      // this.file.patchValue({
      //   character: file
      // });
      this.file = { data: file, inProgress: false, progress: 0 };
    }

    this.upload();
  }
  upload(): void {
    this.filetoUpload.emit(this.file);
  }
}
